// Attributes for inline editing track events
export const INLINE_EDIT_ANALYTICS_ATTRIBUTES = {
	// If the update was made inline (and not via the issue view)
	isInlineEditing: true,
};
